<template>
  <div class="reward">
    <div class="reward-item-container">
      <br>
      <h4 class="text-left"><a href="#" class="admin-clickable" @click.prevent="addRewardItem"><strong>Add Reward Item</strong></a></h4>
      <a href="" @click.prevent="showArchived = !showArchived">Show Archived</a>
      <div class="headers row text-center">
        <div class="col-sm-4">Name</div>
        <div class="col-sm-4">Description</div>
        <div class="col-sm-4">Points</div>
      </div>
      <div
        class="reward-item row clickable text-center"
        :class="{ 'blue-outline': !item.archived, 'red-outline': item.archived }"
        v-for="(item) in sortedRewards" :key="item._id"
        @click="editModal(item._id)"
        >
        <div class="col-sm-4">{{ item.name }}</div>
        <div class="col-sm-4 reward-description" v-html="item.description"></div>
        <div class="col-sm-4">{{ item.points }}</div>
      </div>
    </div>

    <reward-item-modal
      :editRewardItem="editRewardItem"
      :currentRewardItemIndex="currentRewardItemIndex"
      :program="program"
      :isNew="createModal"
      v-on:close="closeModal"
      ></reward-item-modal>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import RewardItemModal from './RewardItemModal'

export default {
  name: 'RewardContent',
  components: {
    'reward-item-modal': RewardItemModal
  },
  data () {
    return {
      currentRewardItemIndex: '',
      editRewardItem: false,
      createModal: false,
      showArchived: false
    }
  },
  computed: {
    ...mapState('loyaltyProgram', [
      'program'
    ]),
    sortedRewards: function () {
      return this.program.rewardItems
        .filter((reward) => {
          return this.showArchived ? true : !reward.archived
        })
    }
  },
  methods: {
    ...mapMutations('loyaltyProgram', {
      updateProgram: 'UPDATE_PROGRAM'
    }),
    editModal (id) {
      const index = this.getIndexFromId(id)
      this.currentRewardItemIndex = index
      this.editRewardItem = true
    },
    closeModal () {
      this.editRewardItem = false
      this.currentRewardItemIndex = null
      this.createModal = false
    },
    getIndexFromId (id) {
      return this.program.rewardItems.findIndex(function (item) {
        return item._id === id
      })
    },
    toReadable (word) {
      let copy = word.toString()
      let words = copy.match(/[A-Za-z][a-z]*/g) || []
      return words.map(word => {
        return word.charAt(0).toUpperCase() + word.substring(1)
      }).join(' ')
    },
    addRewardItem () {
      const copy = this.program.rewardItems.slice()
      copy.push({
        archived: false,
        colors: [],
        sizes: [],
        customColors: [],
        customSizes: [],
        image: { fileName: null, randomString: null, imageKey: null, url: null }
      })
      this.updateProgram({ prop: 'rewardItems', value: copy })
      this.currentRewardItemIndex = copy.length - 1
      this.createModal = true
      this.editRewardItem = true
    }
  }
}
</script>

<style scoped>
.reward-description {
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  display: -webkit-box;
  overflow: auto;
  max-height: 70px;
}

.reward-description * {
  background-color: inherit !important;
  color: inherit !important;
}

.reward-item {
  padding: 10px;
}

.modal-enter-active, .modal-leave-active {
  transition: opacity .6s;
}
.modal-enter, .modal-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
